import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { Trans, useTranslation } from 'next-i18next';
import { useEffect, useRef, useState } from 'react';
import { ExpandButton } from '../../components/ExpandButton/index.js';
import { FormattedText } from '../../components/TourOperatorInfo/components/FormattedText.js';
import { Logo } from '../../components/TourOperatorInfo/components/Logo.js';
import { Title } from '../../components/TourOperatorInfo/components/Title.js';
import { useBooleanToggle } from '../../hooks/index.js';
import { CollapsibleContent, Notice, Stack } from '../../primitives/index.js';
export const TourOperatorInfo = ({
  organizerLogo,
  organizerName,
  organizerNote
}) => {
  const {
    t
  } = useTranslation('tourOperatorInfo');
  const [isExpanded, handleExpand] = useBooleanToggle();
  const [canBeExpanded, setCanBeExpanded] = useState(false);
  const contentRef = useRef(null);
  const minCollapsibleHeight = 200;
  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.getBoundingClientRect().height;
      if (contentHeight > minCollapsibleHeight) {
        setCanBeExpanded(true);
      }
    }
  }, []);
  if (!organizerNote) {
    return null;
  }
  return _jsxs(Stack, {
    spacing: 1.25,
    children: [_jsxs(Title, {
      children: [_jsx(Text, {
        preset: "headlineLarge",
        children: t('title')
      }), organizerLogo ? _jsx(Logo, {
        src: organizerLogo,
        alt: organizerName
      }) : _jsx(Text, {
        preset: "labelMedium",
        children: organizerName
      })]
    }), _jsx(Notice, {
      variant: "info",
      children: _jsx(Trans, {
        t: t,
        i18nKey: "hint",
        components: {
          bold: _jsx("b", {})
        }
      })
    }), canBeExpanded ? _jsx(_Fragment, {
      children: _jsx(CollapsibleContent, {
        minHeight: minCollapsibleHeight,
        hiddenContent: _jsx(FormattedText, {
          ref: contentRef,
          dangerouslySetInnerHTML: {
            __html: organizerNote
          }
        }),
        expanded: isExpanded,
        controls: _jsx(ExpandButton, {
          isExpanded: isExpanded,
          onClick: handleExpand,
          translations: {
            showLess: t('showLess'),
            showMore: t('showMore')
          }
        })
      })
    }) : _jsx(FormattedText, {
      ref: contentRef,
      dangerouslySetInnerHTML: {
        __html: organizerNote
      }
    })]
  });
};